import { Btn, CustomDropdown, CustomModal } from '../../../../../../components'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../../store/actions/system.actions'
import useModalPosicoesAssociadas, { LOAD_MESSAGE } from './ModalPosicoesAssociadasHook'
import { DataTable } from 'primereact/datatable'
import { CustomDataTableHeader } from '../../../../../../components'
import { Column } from 'primereact/column'
import { ColumnGroup } from 'primereact/columngroup'
import { Row } from 'primereact/row'
import { tableCellCentered } from '../../../../../../assets/js/styles'
import { getInventarioQuantityVolumeAndUnits } from '../../inventario-volume-and-units.helper'

function ModalInventario({
  isVisible,
  onClose,
  selectedPosicao,
  inventarioId,
  selectedTp,
  dispatch,
  mode,
}) {
  const { state, localDispatch } = useModalPosicoesAssociadas()

  const renderQteFisicaCell = (prod, type) => {
    const cell = getInventarioQuantityVolumeAndUnits(prod, prod.qte)
    const value = type === 'volume' ? cell.volumeText : cell.unitsText
    const label = type === 'volume' ? cell.customVolumeLabel : cell.customUnitsLabel
    return (
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontWeight: 600 }}>{value}</div>
        {label ? <div style={{ fontSize: '0.72rem', marginTop: 2 }}>{label}</div> : null}
      </div>
    )
  }

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Código" rowSpan={2} />
        <Column header="Produto" rowSpan={2} />
        <Column header="Lote" rowSpan={2} />
        <Column header="Validade" rowSpan={2} />
        <Column header="Qte Fisica" colSpan={2} />
        <Column header="Criado em" rowSpan={2} />
      </Row>
      <Row>
        <Column header="Vol" />
        <Column header="Uni" />
      </Row>
    </ColumnGroup>
  )

  useEffect(() => {
    if (isVisible) {
      localDispatch.onInit(selectedTp, selectedPosicao)
    } else {
      localDispatch.resetModal()
    }
  }, [isVisible])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_CONFS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getConferenciasFromPosicao(
          selectedTp,
          inventarioId,
          selectedPosicao.posicao_estoque_id,
        )
        break

      case LOAD_MESSAGE.GET_PRODUTOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getProdutosFromConferencia(
          selectedTp,
          state.selectedConferencia.conferencia_id,
        )
        break

      case LOAD_MESSAGE.SAVE_CONF:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.saveProdutosConferenciaManual(
          selectedTp,
          state.selectedConferencia.conferencia_id,
          state.produtos,
        )
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <CustomModal width={800} header={`Produtos da Posicão`} isVisible={isVisible} onClose={onClose}>
      <div className="p-grid">
        <div className="p-col-6">
          <CustomDropdown
            label={'Conferência'}
            optionLabel={'conferencia_description'}
            options={state.conferencias}
            value={state.selectedConferencia}
            onChange={value => localDispatch.onChange('selectedConferencia', value)}
            placeholder="Selecione uma conferência"
          />
        </div>
      </div>
      <DataTable
        header={
          <>
            <div className="p-grid p-justify-center" style={{ marginTop: 10, marginBottom: 10 }}>
              <span style={{ display: 'inline-block' }}>
                Posição {selectedPosicao ? selectedPosicao.endereco : ''}
              </span>
            </div>
            <CustomDataTableHeader
              onChange={value => localDispatch.onChange('globalFilter', value)}
              value={state.globalFilter}
              children={
                <div
                  style={{
                    display: mode && mode === 'manual' ? 'inline-flex' : 'none',
                    marginLeft: 25,
                    columnGap: 5,
                  }}
                >
                  <Btn d onClick={() => localDispatch.onClickSalvarContagem(state.produtos)}>
                    Salvar
                  </Btn>
                </div>
              }
            />
          </>
        }
        footer={
          <div style={{ display: 'flex', alignItems: 'center', columnGap: '5px' }}>
            {badgeFaltaSobra(true)} - Falta
            {badgeFaltaSobra(false, true)} - Sobra
          </div>
        }
        globalFilter={state.globalFilter}
        value={state.produtos}
        paginator={true}
        rows={10}
        emptyMessage="Não existem produtos para exibir"
        headerColumnGroup={headerGroup}
      >
        <Column
          field="product_code"
          header="Código"
          style={{
            textAlign: 'center',
            width: '150px',
            wordWrap: 'break-word',
            whiteSpace: 'normal',
          }}
        />
        <Column
          field="product_name"
          header="Produto"
          style={{ wordWrap: 'break-word', whiteSpace: 'normal', minWidth: '200px' }}
          body={prod => (
            <span style={{ display: 'inline-flex', columnGap: 5, alignItems: 'center' }}>
              {badgeFaltaSobra(prod.qte_diff < 0, prod.qte_diff > 0)}
              <span style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                {prod.product_name}
              </span>
            </span>
          )}
        />
        <Column
          field="lote"
          header="Lote"
          style={{
            ...tableCellCentered(),
            width: '100px',
            wordWrap: 'break-word',
            whiteSpace: 'normal',
          }}
        />
        <Column
          field="data_validade"
          header="Validade"
          style={{ ...tableCellCentered(), width: '90px' }}
        />
        <Column
          field="qte"
          header="Vol"
          style={{ ...tableCellCentered(), width: '60px' }}
          body={prod => renderQteFisicaCell(prod, 'volume')}
        />
        <Column
          header="Uni"
          style={{ ...tableCellCentered(), width: '60px' }}
          body={prod => renderQteFisicaCell(prod, 'units')}
        />
        <Column
          field="created_at"
          header="Criado em"
          style={{ ...tableCellCentered(), width: '100px' }}
        />
      </DataTable>
    </CustomModal>
  )
}

export function badgeFaltaSobra(isFalta = false, isSobra = false) {
  if (isFalta)
    return (
      <div
        style={{
          width: 10,
          height: 10,
          border: '1px solid transparent',
          borderRadius: '100%',
          backgroundColor: '#DA0000',
        }}
      ></div>
    )
  if (isSobra)
    return (
      <div
        style={{
          width: 10,
          height: 10,
          border: '1px solid transparent',
          borderRadius: '100%',
          backgroundColor: '#ffaf76',
        }}
      ></div>
    )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(ModalInventario)
